import { GoogleWorkspaceApiClient } from '@wix/google-workspace-api-interface/react-kit';
import { ModalsModule } from '../extensions/ModalsExtensions';
export const useGoogleCustomerCheck = () => {
  const _GoogleWorkspaceApiCl = GoogleWorkspaceApiClient.fetchHooks.useGetGoogleCustomerDetails({}),
    getGoogleCustomerDetailsQuery = _GoogleWorkspaceApiCl.query;
  const googleCustomerExistsModal = ModalsModule.internals.domainsActionsModalsController.googleCustomerExists;
  const checkGoogleCustomerExists = async _ref => {
    let domainName = _ref.domainName;
    try {
      const _await$getGoogleCusto = await getGoogleCustomerDetailsQuery({
          domainName
        }),
        googleCustomerData = _await$getGoogleCusto.data;
      if (googleCustomerData != null && googleCustomerData.found) {
        googleCustomerExistsModal.show({
          domainName
        });
        return true;
      }
    } catch {
      // If the check fails, don't block purchase
    }
    return false;
  };
  return {
    checkGoogleCustomerExists
  };
};
//# sourceMappingURL=useGoogleCustomerCheck.js.map